import BaseModalStore from '@src/components/modal-container/base-modal-store';
import useModal from '@src/utils/hooks/use-modal';
import redeemModal from './redeem-modal';
import RedeemModalStore from './redeem-modal/store';
import { observable } from 'mobx';
import { useMount } from 'ahooks';
import $$tracker from '@src/tracker';

class CdkeyModalStore extends BaseModalStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  $main = {};

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    if (this.redeemModalStore.isActive || this.redeemModalStore.isOpen) {
      this.redeemModalStore.onClickClose();
    } else {
      this.isOpen = false;
      this.isActive = false;
      this.clearStyle();
    }
  };

  login() {
    const { $main } = this;
    const { isDownloadStage } = this.$globalStore;
    if (isDownloadStage) {
      super.login({
        onLoginSuccess: e => {
          const { account } = e;
          this.$globalStore.accountInfo = account;
          this.redeemModal.open();
        }
      });
    } else {
      $main?.bookModal?.open?.({
        appointmentSuccessCallBack: () => {
          this.redeemModal.open();
        }
      });
    }
  }

  redeemCdKey2Steam = () => {
    this.redeemModal.open({ extraStore: { isSteam: true } });
  };

  /**领取奖励 */
  redeemCdKey = () => {
    const { accountInfo } = this.$globalStore;
    if (accountInfo) {
      $$tracker.clickGcyllj();
      this.redeemModal.open();
    } else {
      this.login();
    }
  };

  @observable redeemModal = null;

  @observable redeemModalStore = new RedeemModalStore();

  use() {
    super.use();
    this.redeemModal = useModal(redeemModal, { store: this.redeemModalStore }, { className: 'redeem-modal' });

    const { accountInfo } = this.$globalStore;

    useMount(() => {
      // 一进来先判断是否已经登录，已登录则直接弹窗拷贝窗口
      if (accountInfo) {
        setTimeout(() => {
          this.redeemModal.open({ extraStore: { isSteam: false } });
        }, 1000);
      }
    });
  }
}

export default CdkeyModalStore;
